import React, { useState, useEffect } from "react";
import Modal from "../../components/Modal";
import TextFieldWithLabel from "../../components/TextFieldWithLabel";
import { useFetchApi } from "../../hooks/useFetchApi";

const AddNewModal: React.FC<{
  status: boolean;
  onClose: any;
  onSuccess?: any;
  data?: any;
}> = ({ status, onClose, onSuccess, data = {} }): React.ReactElement => {
  console.log({ data });
  const [d, setD] = useState<any>(data || {});
  const { execute } = useFetchApi(
    "/api/company_quarters",
    {},
    data && Object.keys(data).length ? "PUT" : "POST",
    onSuccess
  );

  const handleChange = (e: any) => {
    const id = e.target.id;
    const value = e.target.value;
    setD({ ...d, [id]: value });
  };

  const handleOnSubmit = (e: any) => {
    execute({ ...d, id: data.id ? data.id : undefined });
    const _e = { ...e, target: { ...e.target, id: "newEdit" } };
    onClose(_e);
  };

  const handleClose = (e: any) => {
    const _e = { ...e, target: { ...e.target, id: "newEdit" } };
    onClose(_e);
  };

  useEffect(() => {
    if (data && Object.keys(data).length) {
      setD(data);
    }

    return () => {
      setD({});
    };
  }, [data]);

  return (
    <Modal
      heading="Add New Company Quarter"
      status={status}
      onClose={handleClose}
      onSubmit={handleOnSubmit}
    >
      <TextFieldWithLabel
        id="name"
        label="Quarter name"
        value={d.name}
        onChange={handleChange}
      />
      <TextFieldWithLabel
        id="month"
        label="Month (1-3, 4-3)"
        value={d.month}
        onChange={handleChange}
      />
      <TextFieldWithLabel
        id="status"
        label="Status"
        value={d.status}
        onChange={handleChange}
      />
    </Modal>
  );
};

export default AddNewModal;
